/**
 * Status possíveis da assinatura
 * - ATIVA: Assinatura ativa e em dia
 * - PENDENTE: Aguardando primeiro pagamento
 * - CANCELADA: Cancelada, acesso até proximaCobranca
 * - DOWNGRADE_AGENDADO: Com downgrade agendado para próxima cobrança
 * - EXPIRADA: Cancelada e período de acesso encerrado
 */
export type StatusAssinatura = 'ATIVA' | 'CANCELADA' | 'DOWNGRADE_AGENDADO' | 'PENDENTE' | 'EXPIRADA';

/**
 * Dados da assinatura atual da imobiliária
 */
export class AssinaturaResponse {
  id: number;
  imobiliariaId: number;
  planoId: number;
  planoNome: string;
  preco: number;
  status: StatusAssinatura;
  dataInicio: Date;
  proximaCobranca: Date;
  downgradeAgendado: boolean;
  planoAgendadoId: number | null;
  planoAgendadoNome: string | null;
  dataUltimaAlteracao: Date;

  constructor(p: any) {
    this.id = p.id ?? null;
    this.imobiliariaId = p.imobiliariaId ?? null;
    this.planoId = p.planoId ?? null;
    this.planoNome = p.planoNome ?? null;
    this.preco = p.preco ?? 0;
    this.status = p.status ?? 'ATIVA';
    this.dataInicio = p.dataInicio ? new Date(p.dataInicio) : null;
    this.proximaCobranca = p.proximaCobranca ? new Date(p.proximaCobranca) : null;
    this.downgradeAgendado = p.downgradeAgendado ?? false;
    this.planoAgendadoId = p.planoAgendadoId ?? null;
    this.planoAgendadoNome = p.planoAgendadoNome ?? null;
    this.dataUltimaAlteracao = p.dataUltimaAlteracao ? new Date(p.dataUltimaAlteracao) : null;
  }
}

/**
 * Response do upgrade de plano
 */
export interface UpgradeResponse {
  message: string;
  novoPlanoId: number;
  novoPlanoNome: string;
  valorProporcional: number;
}

/**
 * Response do downgrade de plano
 */
export interface DowngradeResponse {
  message: string;
  novoPlanoId: number;
  novoPlanoNome: string;
  dataEfetivacao: string;
}

/**
 * Erro de downgrade quando há usuários excedentes
 */
export interface DowngradeErroResponse {
  message: string;
  usuariosAtivos: number;
  limiteNovoPlano: number;
  usuariosExcedentes: number;
}

/**
 * Response do cancelamento de assinatura
 */
export interface CancelarAssinaturaResponse {
  message: string;
  acessoAte: string;
}

/**
 * Response genérico para operações simples
 */
export interface AssinaturaOperacaoResponse {
  message: string;
}
